import { styled, css } from "@mui/system";

export const Styles = styled("div")(
  ({ theme }) => css`
  `
);
